import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import $, { error } from "jquery";
import { useFormik, FormikProvider, Field } from "formik";
import { useRef, useState } from "react";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap";
import moment from "moment-timezone";
import jsPDF from "jspdf";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";
import { FaDownload } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { cloud_url_download } from "../../../Services/Configuration";
import { store } from "../../../App";
import { Link } from "@mui/material";
import { ExportToExcelButton, GetDetails, ModuleHeader, ModuleHeaderTitle } from "../../utils/commonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import axiosTokenServiceKeyCloak from "../../../Services/axiosTokenServiceKeyCloak";
function CbPayments() {
  const history = useHistory();
  const [TableEnable, setTableEnable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [headEnable, setHeadEnable] = useState(false);
  const [headsTableData, setHeadTableData] = useState([]);

  const getPdf = (payment_receipt_id) => {
    HousingService.getPaymentPdf(payment_receipt_id).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );

      let tab = window.open();

      tab.location.href = url;
    });
  };
  const today = new Date().toISOString().split('T')[0];

  const todayDateP = new Date();
  const currentYearCbP = todayDateP.getFullYear();
  const currentMonthCbP = todayDateP.getMonth() + 1;
  const firstDayOfMonthCbP = `${currentYearCbP}-${currentMonthCbP.toString().padStart(2, "0")}-01`;

  const headData = (payment_receipt_id) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.GetHeadsTable(payment_receipt_id).then((response) => {
      if (response && response.data && response.data?.length > 0) { setHeadTableData(response.data); }
      else { setHeadTableData([]); }
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
      setTableEnable(false);
      setHeadEnable(true);
    })
  };


  const backing = () => {
    if (headEnable) {
      setTableEnable(true); setHeadEnable(false);
    }
    else {
      history.goBack();
    }
  };
  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };
  const filteredData = searchText.length > 0 ? tableData?.filter((item) => { return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase())); })); }) : tableData;

  const formik1 = useFormik({
    initialValues: {
      fromDate: firstDayOfMonthCbP,
      toDate: todayDateP.toISOString().substr(0, 10),
      cash_bank: "All"
    },
    validate: (values) => {
      const errors = {};
      if (!values.fromDate) {
        errors.fromDate = "From Date is required";
      }
      if (!values.toDate) {
        errors.toDate = "To Date is required";
      }
      return errors;
    },
    onSubmit: () => {
      let params = { fromDate: moment(formik1.values.fromDate).format("DD-MM-YYYY"), toDate: moment(formik1.values.toDate).format("DD-MM-YYYY"), cash_bank: formik1.values.cash_bank, transaction_type: "P", };
      store.dispatch({ type: "SHOW_SPINNER" });
      HousingService.getCashBankRecipetsData(params)
        .then((responseData) => {
          if (responseData && responseData.data && responseData.data.length > 0) {
            setTableData(responseData.data);
          } else {
            setTableData([]);
          }
        }).catch((error) => {
          console.log(error);
        }).finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
          setTableEnable(true);
          setHeadEnable(false);
        });
    }
  });

  const showNotification = (type, message) => { if (type === "success") { Swal.fire("Success", message, "success"); } else if (type === "error") { Swal.fire("Error", message, "error"); } else if (type === "warning") { Swal.fire("Warning", message, "warning"); } else if (type === "info") { Swal.fire("info", message, "info"); } };
  const [hiddenIcons, setHiddenIcons] = useState({});

  const fileDownload = (upload_copy, index) => {
    if (upload_copy == null) { showNotification("error", "No File Uploaded"); } else {
      setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: true }));
      axiosTokenServiceKeyCloak({
        url: `${cloud_url_download}apofms/Pay_Rec&file=${encodeURIComponent(upload_copy)}`, method: "GET", responseType: "blob"
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: response.headers["content-type"] });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = upload_copy;

          link.click(); window.URL.revokeObjectURL(link.href); setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: false }));
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
          setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: false }));

          if (error.response && error.response.status === 500) {
            showNotification("error", "File Was Deleted, Upload the File Again");
          } else { showNotification("error", "An error occurred while downloading the file"); }
        });
    }
  };
  function PaymentsPDF() {
    const pageWidth = 210; const pageHeight = 297; const imgPath = "/img/APSHCL_logo.png"; const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight] });

    const fromDate = moment(formik1.values.fromDate).format("DD//MM/YYYY");
    const toDate = moment(formik1.values.toDate).format("DD//MM/YYYY");
    const distuser = localStorage.getItem("username");
    const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)"; const headingText3 = `Cash Bank Payments Reports from : ${fromDate}  to : ${toDate} User: ${distuser} `; const headingText4 = "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007"; const fontSize = 12; doc.setFont("times new roman"); doc.setFontSize(fontSize);
    const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor; const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor; const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor; const tableYStart = 45;
    doc.setFontSize(fontSize);
    const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2;
    doc.text(headingText2, xCoordinate2, 10);
    const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2;
    const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2;
    doc.text(headingText3, xCoordinate3, 40);
    doc.text(headingText4, xCoordinate4, 20);
    doc.addImage(imgPath, "PNG", 10, 10, 25, 25);
    doc.autoTable({
      html: "#my-PaymentsPDF", theme: "grid", tableWidth: "auto", columnStyles: { 3: { cellWidth: "wrap" } },
      startY: tableYStart,
      margin: { top: 5, right: 10, bottom: 5, left: 10 }, styles: { fontSize: 8 }, columnWidth: { 0: 20, 1: 30, 2: 40 }
    });

    doc.save("CBPayments.pdf");
  }
  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <ModuleHeaderTitle title="Cash/Bank Payments" />
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
            <button className="btn " style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="button"
              onClick={() => backing()}
            > Back </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik1}>
          <Form onSubmit={formik1.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} ></OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}> <th>From Date:</th>
                <Field name="fromDate" className={formik1.touched.fromDate && formik1.errors.fromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik1.handleChange(e)} max={today} />
                {formik1.touched.fromDate && formik1.errors.fromDate ? (<div className="invalid-feedback"> {formik1.errors.fromDate} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th>To Date:</th>
                <Field name="toDate" className={formik1.touched.toDate && formik1.errors.toDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik1.handleChange(e)} max={today} />
                {formik1.touched.toDate && formik1.errors.toDate ? (
                  <div className="invalid-feedback">{formik1.errors.toDate}</div>
                ) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th>Cash/Bank:</th>
                <Field name="cash_bank" component="select" onChange={(e) => formik1.handleChange(e)} className={formik1.touched.cash_bank && formik1.errors.cash_bank ? "form-control is-invalid" : "form-control"} >
                  <option value="All">All</option>
                  <option value="Cash">Cash</option>
                  <option value="Bank">Bank</option>
                </Field>
              </OFMSUI.Col>
              <GetDetails /> </OFMSUI.Row>
            &nbsp;

            {TableEnable && (
              <>
                <OFMSUI.Row>
                  <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                    <div className="input-group"> <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                      <input type="text" id="#filterInput" placeholder="Search " style={{ width: "25%" }} className="form-control input-lg" value={searchText} onChange={handleSearch} ></input> </div>
                  </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                    <ExportToExcelButton tableId="my-PaymentsPDF" filename="CBPayments" sheet="tablexls" buttonText="Excel" />
                    <button className="btn btn-danger btn-sm" onClick={PaymentsPDF} type="button" style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <div style={{ overflow: "auto", maxHeight: "700px" }}>
                  <Table striped bordered hover id="my-PaymentsPDF" fluid>
                    <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                      <tr style={{ backgroundColor: "#f2f2f2" }}> <th colSpan={12}> <h6><center> Cash / Bank Payments Between from &nbsp; {moment(formik1.values.fromDate).format("DD-MM-YYYY")} &nbsp;to {moment(formik1.values.toDate).format("DD-MM-YYYY")} </center></h6> </th> </tr>
                      <tr className="table_countshead">
                        <th>S No.</th>
                        <th>Transaction Id</th>
                        <th>Received Date</th>
                        <th className="text-center">Voucher No.</th>
                        <th>Received From</th>
                        <th>Mode</th>
                        <th>Ref/Cheque No.</th>
                        <th>Narration</th>
                        <th>Head of Account</th>
                        <th>BankName & A/C No.</th>
                        <th className="text-center">Debit</th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData?.length === 0 || filteredData === undefined ? (<td colSpan="12" style={{ textAlign: "center" }}> No data found </td>) : (filteredData?.filter((element) => element.payment_receipt_id.toLowerCase().includes(searchText.toLowerCase())).map((tableData, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center", width: "40px" }} > {" "} {1 + index} </td> <td style={{ width: "140px" }} onClick={() => { getPdf(tableData.payment_receipt_id); }} > <Link style={{ cursor: "pointer", textDecoration: "none" }}>{tableData.payment_receipt_id}</Link> </td>

                          <td style={{ width: "120px" }}> {tableData.date} </td>
                          <td style={{ width: "100px" }} className="text-right" > {tableData.receiptno} </td> <td style={{ width: "320px" }}> {tableData.name} </td>
                          <td style={{ width: "70px" }}> {tableData.mode} </td> <td style={{ width: "150px" }}> {tableData.cheque_dd_receipt_no} </td> <td style={{ width: "390px" }}> {tableData.receipt_description} </td>
                          <td style={{ width: "140px" }} onClick={() => { headData(tableData.payment_receipt_id); }} > <Link style={{ cursor: "pointer", textDecoration: "none" }}>{tableData.head_of_account}</Link> </td> <td style={{ width: "160px" }}> {tableData.banknameaccountno} </td> <td style={{ width: "80px", textAlign: "right" }} className="sum" >
                            {parseFloat(tableData.paymentamount).toFixed(2)}
                          </td>
                          <td style={{ fontSize: "21px", color: "green", textAlign: "center" }} > {!hiddenIcons[index] && (<FaDownload onClick={() => fileDownload(tableData.upload_copy, index)} />)} </td>
                        </tr>
                      )))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: "0px" }}> <tr className="table_countshead" style={{ textAlign: "right" }}> <td colSpan={10}>Total Amount in Rs/- </td> <td>
                      {tableData?.reduce((a, v) => a + parseFloat(v.paymentamount || 0), 0)
                        .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                      <td></td> </tr> </tfoot>
                  </Table>
                </div>
              </>
            )}
            &nbsp;
            {headEnable && (
              <>
                <Table striped bordered hover className="mb-5">
                  <thead className="fw-bold">
                    <tr style={{ backgroundColor: "#f2f2f2" }}> <th colSpan={12}> <h6><center> Cash Bank Payment Head Details </center></h6> </th> </tr>
                    <tr className="table_countshead">
                      <th style={{ width: "5%" }}>S.no</th>
                      <th style={{ width: "45%" }}>Heads</th>
                      <th style={{ width: "45%" }}>SubHeads</th>
                      <th className="text-center">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {headsTableData?.map((data, i) => (
                      <tr key={i}>
                        <td>{i + 1} </td>
                        <td>{data.heads} </td>
                        <td>{data.subheads}</td>
                        <td className="text-right">{parseFloat(data.amount).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot> <tr className="table_countshead text-right"> <td colSpan={3} > Total Amount in Rs </td> <td> {" "}
                    {headsTableData?.reduce((a, v) => a + parseFloat(v.amount || 0), 0)
                      .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td> </tr> </tfoot>
                </Table>
              </>
            )}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default CbPayments;
